// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListTodo as RawListTodo } from "lucide-react";
export const ListTodo = /* @__PURE__ */ createIcon(RawListTodo, "ListTodo", 2);
